import React, { useEffect, useState, useRef } from 'react';
import { initializeWebSocket, sendMessage } from '../api/api';

function StorySummary() {
  const [summary, setSummary] = useState('');
  const [percent, setPercent] = useState(0); // 修正变量名为 percent
  const [aiConnectionStatus, setAiConnectionStatus] = useState(false); // 添加 ai_connecttion_status 状态
  const [statusMessage, setStatusMessage] = useState('AI连接中'); // 初始化 statusMessage 状态
  const [script, setScript] = useState('生成的梗概将会显示在这里'); // 添加 script 状态
  const wsRef = useRef(null); // 使用 useRef 存储 WebSocket 连接
  const [isButtonPressed, setIsButtonPressed] = useState(false); // 添加 isButtonPressed 状态

  useEffect(() => {
    const ws = initializeWebSocket();
    wsRef.current = ws; // 将 WebSocket 连接存储到 useRef

    ws.onopen = () => {
      console.log('Connected to server');
      setAiConnectionStatus(true); // 更新连接状态
      setStatusMessage('AI已经连接'); // 更新状态消息
    };

    ws.onmessage = (event) => {
      console.log('Message from server:', event.data);
      // 解析，只放入 message 部分在 status 中
      const parsedData = JSON.parse(event.data);
      setStatusMessage(parsedData.message); // 更新状态消息
      if(parsedData.status === "script"){
        setScript(prevScript => prevScript === '生成的梗概将会显示在这里' ? convertMarkdownToHtml(parsedData.message) : prevScript + convertMarkdownToHtml(parsedData.message)); // 替换或增加梗概
      }
      if(parsedData.index == 2){
        endTimeCount();
      }
    };

    ws.onclose = () => {
      console.log('Disconnected from server');
      setAiConnectionStatus(false); // 更新连接状态
      setStatusMessage('AI已经断开'); // 更新状态消息
      setPercent(0);
    };

    // 在组件卸载时关闭 WebSocket 连接
    return () => {
      ws.close();
    };

  }, []);
   
  function convertMarkdownToHtml(markdown) {
    // 使用正则表达式将 markdown 转换为 HTML 格式
    let htmlText = markdown
      .replace(/(\*\*|__)(.*?)\1/g, '<strong>$2</strong>') // 转换加粗
      .replace(/(\*|_)(.*?)\1/g, '<em>$2</em>')   // 转换斜体
      .replace(/(~~)(.*?)\1/g, '<del>$2</del>')   // 转换删除线
      .replace(/`([^`]+)`/g, '<code>$1</code>')   // 转换行内代码
      .replace(/```([\s\S]*?)```/g, '<pre><code>$1</code></pre>') // 转换代码块
      .replace(/!\[.*?\]\((.*?)\)/g, '<img src="$1" alt="" />') // 转换图片
      .replace(/\[([^\]]+)\]\((.*?)\)/g, '<a href="$2">$1</a>') // 转换链接
      .replace(/(#+)\s(.*)/g, (match, p1, p2) => `<h${p1.length}>${p2}</h${p1.length}>`) // 转换标题
      .replace(/>\s(.*)/g, '<blockquote>$1</blockquote>') // 转换引用
      .replace(/[-*+]\s(.*)/g, '<li>$1</li>') // 转换无序列表符号
      .replace(/\d+\.\s(.*)/g, '<li>$1</li>') // 转换有序列表符号
      .replace(/<\/li>\n<li>/g, '</li><li>') // 合并列表项
      .replace(/(<li>.*<\/li>)/g, '<ul>$1</ul>') // 包裹列表项
      .replace(/\n{2,}/g, '<br/>'); // 转换多余的换行

    return htmlText;
  }

  function startTimeCount() {
    console.log('计时开始');
    const intervalId = setInterval(() => {
      setPercent(prevPercent => {
        const newPercent = prevPercent + 1;
        if (newPercent >= 100) {
          clearInterval(intervalId);
          endTimeCount(intervalId);
        }
        return newPercent;
      });
    }, 1000);
    // 可以在这里添加更多逻辑，例如记录开始时间
    return intervalId; // 返回 intervalId 以便在需要时清除
  }

  function endTimeCount(intervalId) {
    console.log('计时结束');
    setPercent(100); // 设置 percent 为 1
    clearInterval(intervalId); // 移除计时器
    setIsButtonPressed(false);
  }

  function generateSummary() {
    const templates = JSON.parse(localStorage.getItem('selectedTemplateNames')) || [];
    const storysettings = JSON.parse(localStorage.getItem('selectedStorysettingNames')) || [];
    const worldviews = JSON.parse(localStorage.getItem('selectedWorldviewNames')) || [];
    const genres = JSON.parse(localStorage.getItem('selectedGenreNames')) || [];
    const characterdesigns = JSON.parse(localStorage.getItem('selectedCharacterdesignNames')) || [];
    const model = "gpt-4o";
    const token = localStorage.getItem('token') || '';


    setIsButtonPressed(true);

    if (wsRef.current) {
      sendMessage(wsRef.current, "", "", templates, storysettings, worldviews, genres, characterdesigns, model, token);
      startTimeCount();
    }  
  }

  return (
    <div style={{
      backgroundImage: 'url(/images/background.png)',
      backgroundSize: 'cover',
      height: '100vh',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'column',
      overflow: 'hidden'
    }}>
      <img src="/images/title.png" alt="Title" style={{
        position: 'absolute',
        top: '10px',
        left: '30px',
        width: '60px'
      }} />
      <div style={{
        position: 'absolute',
        top: '25px',
        right: '40px',
        fontWeight: 'bold',
        fontSize: '18px'
      }}>
        故事梗概生成
      </div>

      <div 
        style={{ 
          flex: 1, 
          display: 'flex', 
          flexDirection: 'column', 
          alignItems: 'center', 
          backgroundColor: 'white', 
          borderRadius: '15px', 
          border: '1px solid rgba(0, 0, 0, 0.1)', 
          position: 'fixed', 
          top:'80px',
          width:'80%',
          left:'5%',
          padding: '20px',
        }}>

        <div style={{
          width:'100%',
          height: '40px',
          position:'relative',
          top:'-15px',
          backgroundColor: 'rgba(217, 217, 217, 0.1)',
          borderRadius: '15px',
          padding: '15px',
        }}>
          <div style={{
            fontSize: '8px',
            fontWeight: 1000
          }}> 当前AI处理进度：</div>
          <div style={{
            paddingLeft: '20px',
            paddingRight: '20px',
            width: '90%',
            marginTop: '10px',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between'
          }}>
            <div style={{
              width: '500%',
              height: '20px',
              overflowY: 'auto',
              marginRight: '20px',
              fontSize:'10px',
            }}>
              {aiConnectionStatus ? statusMessage : 'AI连接中'}
            </div>
            <div style={{
              width: '100%',
              backgroundColor: '#e0e0e0',
              borderRadius: '15px',
              overflow: 'hidden',
              position: 'relative',
              height: '15px'
            }}>
              <div style={{
                width: `${percent}%`, // 修正变量名为 percent
                backgroundColor: 'black',
                height: '15px'
              }}></div>
              <span style={{
                position: 'absolute',
                top: '5px',
                right: '5px',
                fontSize: '3px',
                color: 'gray'
              }}>
                {Math.round(percent / 10) * 10 + '%'} 
              </span>
            </div>
          </div>
        </div>

        <div
          contentEditable
          style={{
            width: '90%',
            border: '1px solid rgba(0, 0, 0, 0.1)',
            borderRadius: '15px',
            padding: '25px',
            color: '#333',
            fontSize: '12px',
            lineHeight: '1.5',
            height: 'calc(100vh - 500px)',
            overflowY: 'auto',
            resize: 'none',
            zIndex: 9999
          }}
          dangerouslySetInnerHTML={{ __html: script }} // 使用 dangerouslySetInnerHTML 来插入 HTML
        />
      </div>

      <div style={{
         width: '300px',
         display: 'flex',
         flexDirection: 'column',
         alignItems: 'center',
         justifyContent: 'center',
         position: 'fixed',
         bottom: '150px',
         fontSize: '12px',
         color: 'gray'

      }}>
        <p>继续请在电脑端打开</p>
        <a href="https://www.zcsh.top" target="_blank">https://www.zcsh.top</a>
        <p>享受更多，更好的 AI 功能</p>
      </div>

      <div style={{
        width: '300px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'fixed',
        top: '150px'
      }}>
       <button 
          onClick={generateSummary}
          disabled={isButtonPressed}
          style={{
            position: 'fixed',
            bottom: '50px',
            padding: '10px 20px',
            fontSize: '16px',
            width: '55%',
            height: '80px',
            backgroundColor: isButtonPressed ? 'gray' : 'black',
            color: isButtonPressed ? 'darkgray' : 'white',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer'
          }}>
            生成梗概
      </button>
      </div>
    </div>
  );
}

export default StorySummary;
